import React from 'react';
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend
} from 'recharts';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8', '#82ca9d'];

export default function AnalyticsChart({ 
  type = 'line', 
  data = [], 
  xKey = 'period', 
  yKey = 'count',
  title,
  height = 300,
  showGrid = true,
  showTooltip = true,
  showLegend = false,
  color = '#3B82F6'
}) {
  if (!data || data.length === 0) {
    return (
      <div style={{ 
        height, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        color: '#666',
        background: '#f9f9f9',
        borderRadius: '8px'
      }}>
        No data available
      </div>
    );
  }

  const commonProps = {
    data,
    height,
    margin: { top: 20, right: 30, left: 20, bottom: 5 }
  };

  switch (type) {
    case 'line':
      return (
        <div>
          {title && <h4 style={{ marginBottom: '1rem', color: '#333' }}>{title}</h4>}
          <ResponsiveContainer width="100%" height={height}>
            <LineChart {...commonProps}>
              {showGrid && <CartesianGrid strokeDasharray="3 3" />}
              <XAxis dataKey={xKey} />
              <YAxis />
              {showTooltip && <Tooltip />}
              {showLegend && <Legend />}
              <Line 
                type="monotone" 
                dataKey={yKey} 
                stroke={color}
                strokeWidth={2}
                dot={{ fill: color, strokeWidth: 2, r: 4 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      );

    case 'bar':
      return (
        <div>
          {title && <h4 style={{ marginBottom: '1rem', color: '#333' }}>{title}</h4>}
          <ResponsiveContainer width="100%" height={height}>
            <BarChart {...commonProps}>
              {showGrid && <CartesianGrid strokeDasharray="3 3" />}
              <XAxis dataKey={xKey} />
              <YAxis />
              {showTooltip && <Tooltip />}
              {showLegend && <Legend />}
              <Bar dataKey={yKey} fill={color} radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      );

    case 'pie':
      return (
        <div>
          {title && <h4 style={{ marginBottom: '1rem', color: '#333' }}>{title}</h4>}
          <ResponsiveContainer width="100%" height={height}>
            <PieChart>
              <Pie
                data={data}
                dataKey={yKey}
                nameKey={xKey}
                cx="50%"
                cy="50%"
                outerRadius={80}
                fill={color}
                label
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              {showTooltip && <Tooltip />}
              {showLegend && <Legend />}
            </PieChart>
          </ResponsiveContainer>
        </div>
      );

    default:
      return <div>Unsupported chart type: {type}</div>;
  }
}